export default __webpack_public_path__ + "static/media/arial-bold-italic.56c9a413.ttf";